export enum ItemType {
    Series = 'series',
}
